import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import TextFieldStoreMessage from '../../../components/CRM/TextFieldStoreMessage';
import { Datagrid, TextField, translate } from "admin-on-rest";
import ActionBar from "../../../components/CRM/ActionBar/";
import StoreMessageFilter from "./StoreMessageFilter";
import ActionMenu from "../../../components/CRM/ActionMenu";
import DateField from "../../../components/CRM/DateField.js";
import {refreshView as refreshViewAction} from "admin-on-rest";

class StoreMessageDataListBase extends React.Component {

  postRowStyle = (record, index) => {
    return {opacity: record.kiosk_deleted ? "0.5" : "1"}
  };
  
  render() {
    const props = {...this.props};

    return (
      <List
        title="resources.storeMessages.name"
        {...props}
        actions={<ActionBar {...props} deleteButton={false} />}
        sort={{field: "name", order: "ASC"}}
        filters={<StoreMessageFilter />}
      >
        <Datagrid rowStyle={this.postRowStyle}>
          <TextFieldStoreMessage
            label="resources.storeMessages.fields.storeName"
            source="kiosk_name"
          />

          <TextField
            label="resources.storeMessages.fields.smsFrom"
            source="sms_from"
          />
          <TextField
            label="resources.storeMessages.fields.emailFrom"
            source="email_from"
          />
          <TextField
            label="resources.storeMessages.fields.emailSubject"
            source="email_subject"
          />
          <DateField
            label="resources.storeMessages.fields.sentAt"
            source="sent_at"
          />

          <ActionMenu
            showButton={true}
            editButton={false}
            deleteButton={false}
          />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource],
    kiosks: state.admin.resources.kiosks.data
  };
};

const StoreMessageDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(StoreMessageDataListBase);

export default translate(StoreMessageDataList);



// WEBPACK FOOTER //
// ./src/containers/CRM/StoreMessages/StoreMessageDataList.js